module.exports = __webpack_public_path__ + "static/media/full_program.ae86649f.jpg";